module.exports = __webpack_public_path__ + "images/edges_grey@3x.png?b818d1aa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edges_grey@3x.png
// module id = 620
// module chunks = 7